import { ComputeChart } from "~/components/shared/ComputeChart/chart";

export default ComputeChart;
